import React from 'react';
import styled from '@emotion/styled';
import {
    GroupPanel,
    Grouping
} from 'devextreme-react/data-grid';

import { TCommonProps, TForwardedRef } from 'types/gridDefs';

import { DataGridBase } from './DataGrid/DataGrid.Base';
import { ErrorBoundary } from './Error/ErrorBoundary';
import * as groupHelpers from './helpers/groupHelpers';

/* ======================================== */

type TProps = TCommonProps;

/* ======================================== */

export const StyledDataGridBase = styled(DataGridBase)(
    () => ({
        '&.dx-widget .dx-datagrid': {
            '& tr, & tr.dx-group-row': {
                // showing group/summary row, but with no collapsing - hide the expander column completely
                '& > td.dx-command-expand, & > td.dx-command-expand:first-of-type': {
                    width: '0!important',
                    minWidth: '0!important',
                    maxWidth: '0!important',
                    padding: 0,
                    borderWidth: 0,

                    '& > div': {
                        display: 'none'
                    }
                },
                '& > td.dx-group-cell': {
                    borderLeftWidth: 0
                }
            }
        }
    })
);

/* ======================================== */

/**
 * Standard adserve DataGrid with grouping / summary rows - but no collase (ie details of each group always visible)
 * !! prototype: still under development !!
 * @public
 */
export const AsDataGridGroupNoCollapse = React.forwardRef<TForwardedRef, TProps>((props, forwardedRef) => {
    return (
        <ErrorBoundary name='AsDataGridGroupNoCollapse'>
            <StyledDataGridBase
                {...props}
                ref={forwardedRef}
            >
                <Grouping
                    allowCollapsing={false}
                    contextMenuEnabled={false}
                    expandMode='buttonClick'
                    texts={groupHelpers.groupingTexts}
                />
                <GroupPanel
                    visible={false}
                    allowColumnDragging={false}
                    emptyPanelText=''
                />
            </StyledDataGridBase>
        </ErrorBoundary>
    );
});
